export const GET_LOG_LIST = "GET_LOG_LIST";

export const SET_LOADING = "SET_LOADING";
export const SET_DATATABLE_FILTER = "SET_DATATABLE_FILTER";

export const TRANSACTION_LOG_LIST = "TRANSACTION_LOG_LIST";
export const BANK_ACCOUNT_LOG_LIST = "BANK_ACCOUNT_LOG_LIST";
export const MEMBER_LOG_LIST = "MEMBER_LOG_LIST";
export const ADMIN_LOG_LIST = "ADMIN_LOG_LIST";